export default {
  'ja': {
    'wareki': [
      {'gengou': '平成', 'gengou_end': '99', 'str_date': '19890108', 'end_date': '20991231'},
      {'gengou': '昭和', 'gengou_end': '64', 'str_date': '19261225', 'end_date': '19890107'},
      {'gengou': '大正', 'gengou_end': '15', 'str_date': '19120730', 'end_date': '19261224'},
      {'gengou': '明治', 'gengou_end': '45', 'str_date': '18670908', 'end_date': '19120729'}
    ],
    'ymd': {
      'year': '年',
      'month': '月',
      'day': '日'
    },
    'sex': {0: '男', 1: '女'},
    'AllShopName': '全店舗',
    'none_list': {
      'id': '',
      'name': '-- なし --'
    },
    'all_list': {
      'id': '',
      'name': '-- 全て --'
    },
    'attributes': {
      'patient': {
        'patient-name': '患者名',
        'patient-name-furigana': 'ふりがな',
        'sex': '性別',
        'birthday': '生年月日',
        'age': '年齢',
        'room': '部屋番号',
        'tel': '電話番号',
        'address1': '住所１',
        'address2': '住所２',
        'emergency_name': '緊急連絡先',
        'emergency_rel': '族柄',
        'emergency_tel': '電話番号',
        'emergency2_name': '緊急連絡先2',
        'emergency2_rel': '族柄',
        'emergency2_tel': '電話番号',
        'special-comment': '特記事項、調剤訪問における注意事項'
      },
      'patient-report': {
        'prescriptiondate': '処方日',
        'visitdate': '訪問日',
        'status': '状態'
      },
      'report-history': {
        'patient-name': '患者名',
        'delivery-date': '訪問日',
        'clinic-send': 'クリニック送信',
        'careman-send': 'ケアマネ送信'
      },
      'report-batch-history': {
        'send-to': '送信先',
        'send-type': '送信方法',
        'send-status': '送信状態',
        'send-time': '送信時間',
        'send-count': '件数',
        'send-error': '送信エラー',
        'patient-name': '患者名',
        'delivery-date': '訪問日'
      },
      'facility-list': {
        'facility-name': '施設名',
        'facility-type': '施設種類',
        'tel': 'TEL'
      }
    },
    'patient_list_list': {
      'label': {
        'patient-png': '患者写真',
        'patient-name': '名前',
        'sex': '性別',
        'birthday': '生年月日',
        'age': '年齢',
        'facility-name': '施設名'
      },
      'btn': {
        'icon_upload': '患者写真アップロード',
        'medicine_list': '薬情一覧'
      }
    },
    'patient_list_plan': {
      'patient_code': '患者コード　'
    },
    // 一括印刷
    'print-all': {
      'plan': '計画書',
      'report': '報告書',
      'confirm_title': '一括印刷',
      'confirm_message': '{count} 件の {name} を検索しました。一括印刷しますか？',
      'download_title': 'PDFファイル圧縮',
      'download_message': 'しばらくお待ちください。PDFファイルを {proc} です。',
      'proc_zip': '圧縮中',
      'proc_build': '生成中',
      'not_exist_message': '{name} が存在しません。',
      'show_pdf_message': 'ＰＤＦを表示するにはここをクリックしてください。',
      'report_types': [
        {'id': 0, 'text': '居宅療養管理指導'},
        {'id': 1, 'text': '薬歴'},
        {'id': 2, 'text': '在宅患者薬剤管理指導'},
        {'id': 4, 'text': 'かかりつけ薬剤師指導'},
        {'id': 5, 'text': 'かかりつけ薬剤師包括管理'},
        {'id': 3, 'text': '報告なし'},
        {'id': '', 'text': '-- 全て --'}
      ],
      'report_sort_fields': [
        {'id': 1, 'text': 'クリニック'},
        {'id': 2, 'text': '介護支援事業所'},
        {'id': 3, 'text': '施設名'},
        {'id': 4, 'text': '処方医名'},
        {'id': 5, 'text': 'ケアマネ名'},
        {'id': 6, 'text': '患者名'},
        {'id': 7, 'text': '訪問日'},
        {'id': 8, 'text': '調剤日'},
        {'id': 9, 'text': '処方日'},
        {'id': 10, 'text': '服用開始日'},
        {'id': 11, 'text': '部屋番号'}
      ],
      'plan_sort_fields': [
        {'id': 1, 'text': 'クリニック'},
        {'id': 2, 'text': '介護支援事業所'},
        {'id': 3, 'text': '施設名'},
        {'id': 4, 'text': '処方医名'},
        {'id': 5, 'text': 'ケアマネ名'},
        {'id': 6, 'text': '患者名'},
        {'id': 7, 'text': '計画作成日'},
        {'id': 8, 'text': '部屋番号'}
      ],
      'label': {
        'doc_type': '種類',
        'shop': '店舗',
        'type': 'タイプ',
        'plan_date': '作成日',
        'patient_name': '患者名',
        'report_header': '送付状',
        'nashi': '無',
        'ari': '有',
        'facility': '施設',
        'facility_name': '施設名',
        'delivery_date': '訪問日',
        'clinic': 'クリニック',
        'clinic_name': 'クリニック名',
        'postal': '郵送分',
        'make_date': '調剤日',
        'care_office': '介護支援事業所',
        'care_office_name': '介護支援事業所名',
        'prescribe_date': '処方日',
        'sort_fields': '並替設定',
        'sort': '並替',
        'sort_desc': '降順',
        'sort_asc': '昇順',
        'zip_file': '圧縮ファイル',
        'pdf_file': 'まとめPDF'
      }
    },
    'placeholder': {
      'shop': '店舗',
      'facility': '施設名',
      'facility_person': '個人宅名',
      'clinic': 'クリニック名',
      'care_office': '介護支援事業所名',
      'patient': '患者名',
      'fax': 'FAX番号',
      'email': 'example@gmail.com',
      'date': 'YYYY/MM/DD',
      'time': 'HH:MM',
      'clinic_name': '医療機関名',
      'doctor_name': '処方医名',
      'reportor_name': '作成者',
      'delivery_date': '訪問日',
      'doctor': '医師名',
      'careman': 'ケアマネジャー',
      'furigana': 'ふりがな',
      'post_no': '郵便番号',
      'address1': '住所１',
      'address2': '住所２'
    },
    'send-type': {
      '1': '郵送',
      '2': 'FAX',
      '4': 'メール',
      '8': '持参'
    },
    'send-status': {
      '0': '未送信',
      '1': '送信成功',
      '2': '送信失敗',
      '3': '送信中',
      '4': '送信中止',
      '5': '全状態'
    },
    'week_days': [
      {'id': 0, 'text': '日曜日'},
      {'id': 1, 'text': '月曜日'},
      {'id': 2, 'text': '火曜日'},
      {'id': 3, 'text': '水曜日'},
      {'id': 4, 'text': '木曜日'},
      {'id': 5, 'text': '金曜日'},
      {'id': 6, 'text': '土曜日'}
    ],
    // 施設
    'facility': {
      'input_date': '入力日',
      'change_date': '変更日',
      'facility_type': '施設種類',
      'facility_name': '施設名',
      'home_name': '個人宅名',
      'furigana': 'ふりがな',
      'company_name': '会社名',
      'main_clinic': '主な処方元',
      'prescription_receive': '処方箋回収',
      'post_no': '郵便番号',
      'address': '住所',
      'contact': '連絡先',
      'tel': 'TEL',
      'fax': 'FAX',
      'mail': 'メール',
      'send_type': '送付方法',
      'boss_name': '施設長',
      'medman_name': '薬の管理者',
      'delivery_date': '配達日',
      'delivery_time': '配達時間',
      'delivery_note': '配達特記事項',
      'deli_days_example': '例：1,11,21',
      'med_storage': '薬の保管場所',
      'medicine': '薬',
      'hotchkiss': 'ホチキス等',
      'stamp': '印字',
      'stamp_edit': '印字編集',
      'stamp_width': '幅',
      'stamp_draw': '薬袋描写',
      'stamp_other': 'その他　色線や調剤のルール',
      'notice': '注意事項',
      'limit_date': '完了期限',
      'arbitrary_division': '任意区分',
      'digits': '{n}桁',
      'digit': '{n}桁目',
      'facility_code_example': '施設コード　例：21',
      'floor_code_example': 'フロアーコード　例：1',
      'floor_name_example': 'フロアー名　例：1階',
      'pay_type': '支払方法',
      'pay_format': 'フォーマット',
      'pay_option': 'オプション',
      'charge_shops': '担当店舗',
      'delivery_day_input': '配達日入力',
      'reception_day': '受付日の次の',
      'first': '第一',
      'second': '第二',
      'third': '第三',
      'fourth': '第四',
      'fifth': '第五',
      'day': '日',
      'every_week': '毎週',
      'every_month': '毎月',
      'other': 'その他',
      'facility_deal_ends': 'この施設は取引中止されました。',
      'facility_info': '施設情報',
      'delivery_method': 'お渡し方法',
      'infomation': '情報',
      'dispensing': '調剤',
      'acceptance': '申し送り',
      'facility_acceptance': '施設申し送り',
      'limit': '期限',
      'creator_name': '入力者',
      'loginid_password_notice': 'ログインIDとパスワードの通知',
      'resume_deal': '取引再開',
      'pdf_output': 'PDF出力',
      'notice_confirm': '先方へログインID・パスワードを通知します。よろしいですか？',
      'new_regist': '新規登録',
      'duplicate_check': '重複チェック',
      'select_all': '全施設選択',
      'clear': 'クリア',
      'surrounding': '周辺施設表示',
      'duplicate_tel_confirm': '登録確認',
      'duplicate_tel_message': '同じ電話番号がすでに登録済みです。このまま登録してよろしいですか？',
      'facility_photo_upload_message': 'ここにファイルをドロップしてください',
      'delete_confirm': '削除確認',
      'delete_confirm_text': '施設履歴を削除します。よろしいでしょうか？',
      'select_none': '-- 施設種類 --',
      'title_facility_edit': '施設編集',
      'title_facility_new': '施設新規登録',
      'title_person_edit': '個人宅編集',
      'title_person_new': '個人宅新規登録',
      'mm_width': 'mm 幅',
      'pdf_format': {
        'A': 'フォーマットA　患者名+請求金額合計',
        'B': 'フォーマットB　患者名+介護費+医療費+合計金額',
        'C': 'フォーマットC　患者名（フロアーコード）+請求金額合計'
      },
      'send_types': [
        {'id': 1, 'text': '郵送'},
        {'id': 2, 'text': 'FAX'},
        {'id': 4, 'text': 'メール'}
      ],
      'send_timing': [
        {'id': 0, 'text': '当日○時間後送付'},
        {'id': 1, 'text': '１週間まとめ送付'},
        {'id': 2, 'text': '２週間まとめ送付'}
      ],
      'send_timing_hour': [
        {'id': '0.0', 'text': '０分後'},
        {'id': '0.5', 'text': '３０分後'},
        {'id': '1.0', 'text': '１時間後'},
        {'id': '2.0', 'text': '２時間後'},
        {'id': '3.0', 'text': '３時間後'},
        {'id': '4.0', 'text': '４時間後'},
        {'id': '5.0', 'text': '５時間後'},
        {'id': '6.0', 'text': '６時間後'},
        {'id': '7.0', 'text': '７時間後'},
        {'id': '8.0', 'text': '８時間後'},
        {'id': '9.0', 'text': '９時間後'},
        {'id': '10.0', 'text': '１０時間後'},
        {'id': '12.0', 'text': '１２時間後'}
      ],
      'am_pm': [
        {'id': 0, 'text': 'AM(9:00-13:00)'},
        {'id': 1, 'text': 'PM(13:00-19:00)'}
      ],
      'packages': [
        {'id': 1, 'text': '手渡し（ビニール袋）'},
        {'id': 2, 'text': '手渡し（ユニパック）'},
        {'id': 4, 'text': '手渡し（ユニパック、外用・頓服のみ薬袋）'}
      ],
      'package_sets': [
        {'id': 1, 'text': 'セット（ＢＯＸ）'},
        {'id': 2, 'text': 'セット（カレンダー）'}
      ],
      'manuals': [
        {'id': 1, 'text': '薬情'},
        {'id': 2, 'text': '手帳ラベル'},
        {'id': 4, 'text': '明細書'}
      ],
      'hotchkisses': [
        {'id': 1, 'text': 'なし'},
        {'id': 2, 'text': 'ホチキス留め'},
        {'id': 4, 'text': 'テープ留め'},
        {'id': 8, 'text': 'その他'}
      ],
      'pay_formats': [
        {'id': 'A', 'text': 'A'},
        {'id': 'B', 'text': 'B'},
        {'id': 'C', 'text': 'C'}
      ],
      'pay_options': {
        '1': '備考欄　訪問日/金額記録',
        '2': '0円除外'
      },
      'stamp_types': [
        {'id': 'A', 'text': '日付・名前・用法'},
        {'id': 'B', 'text': '名前・用法・病院名'},
        {'id': 'C', 'text': '名前・用法'},
        {'id': 'D', 'text': '名前・用法・病院名・薬品名'},
        {'id': 'E', 'text': '線あり・日付・名前・用法・病院名'},
        {'id': 'G', 'text': '太線あり・日付・名前・用法・病院名'},
        {'id': 'I', 'text': '日付・名前・用法・病院名'}
      ]
    },
    'clinic': {
      'clinic_name': 'クリニック名',
      'title_edit': 'クリニック編集',
      'title_new': 'クリニック新規登録',
      'new_regist': '新規登録',
      'duplication_check': '重複チェック',
      'clinic_disabled': 'このクリニックは取引中止されました。',
      'address': '住所',
      'tel': 'TEL',
      'fax': 'FAX',
      'email': 'メール',
      'send_type': '送付方法',
      'fusezi': '伏字対応',
      'fusezi_nashi': 'なし',
      'fusezi_msg1': '報告書送信の時に患者名を伏字出力',
      'fusezi_msg2': '（例：山本　亮一 => ◯本　◯一）',
      'login_id_prefix': 'KC',
      'charge_shops': '担当店舗',
      'torihiki_stop': '取引中止',
      'torihiki_start': '取引再開',
      'pdf_output': 'PDF出力',
      'send_types': [
        {'id': 1, 'text': '郵送'},
        {'id': 2, 'text': 'FAX'},
        {'id': 4, 'text': 'メール'}
      ],
      'send_timing': [
        {'id': 0, 'text': '当日○時間後送付'},
        {'id': 1, 'text': '１週間まとめ送付'},
        {'id': 2, 'text': '２週間まとめ送付'}
      ],
      'send_timing_hour': [
        {'id': '0.0', 'text': '０分後'},
        {'id': '0.5', 'text': '３０分後'},
        {'id': '1.0', 'text': '１時間後'},
        {'id': '2.0', 'text': '２時間後'},
        {'id': '3.0', 'text': '３時間後'},
        {'id': '4.0', 'text': '４時間後'},
        {'id': '5.0', 'text': '５時間後'},
        {'id': '6.0', 'text': '６時間後'},
        {'id': '7.0', 'text': '７時間後'},
        {'id': '8.0', 'text': '８時間後'},
        {'id': '9.0', 'text': '９時間後'},
        {'id': '10.0', 'text': '１０時間後'},
        {'id': '12.0', 'text': '１２時間後'}
      ],
      'modal': {
        'id_pass_notify_confirm': 'ログインIDとパスワードの通知',
        'id_pass_notify_message': '先方へログインID・パスワードを通知します。よろしいですか？',
        'delete_confirm': '削除確認',
        'delete_msg': 'クリニック履歴を削除します。よろしいでしょうか？',
        'duplicate_tel_confirm': '登録確認',
        'duplicate_tel_message': '同じ電話番号がすでに登録済みです。このまま登録してよろしいですか？'
      },
      'clinic_code': 'クリニックコード　'
    },
    'validations': {
      'required': '必須項目です。',
      'invalid_post_no': '3文字以上の半角数字を入力してください。ハイフンは含めないで下さい。',
      'invalid_tel': '例：半角数字090-1234-5678',
      'invalid_email': '例：tanaka@gmail.com',
      'invalid_maxlength': '文字以下に入力してください。',
      'invalid_pdf': 'PDFファイルではありません。',
      'invalid_date': '例：平成9年1月1日',
      'no_data': 'データーがありません。',
      'no_equal_password': '同じパスワードを入力してください。',
      'invalid_taking_period': '半角数字を入力して下さい。',
      'invalid_furigana': 'ひらがなを入力してください。',
      'send_method': '送付方法を選択してください。',
      'future_date': '現在、変更日に未来日を設定することはできません。',
      'print_length': '印刷に収まらない可能性があります。改行または１行の文字数を減らして下さい。',
      'password_confirmation': '同じパスワードを入力してください。'
    },
    'plan': {
      'confirm_title': '確認',
      'confirm_message': '翌月分の計画書はすでに作成されています。上書きしますか？',
      'next_plan_confirm_message': '{year}年 {month}月分の計画書を作成しますか？',
      'next_plan_confirm_message2': '※先月以前の計画書であるため、自動作成されません。',
      'copy_edit_filure_message': 'すでに計画書が存在しています。計画作成日を変更して下さい。',
      'save_success_message': '翌月分の計画書を作成しました。',
      'save_failure_message': '翌月分の計画書作成が失敗しました。',
      'edit_next_month_success_message': '計画書を作成しました。',
      'edit_next_month_filure_message': '計画書作成が失敗しました。',
      'set_disable_success_message': '受付中止にしました。',
      'set_enable_success_message': '受付を再開しました。',
      'confirm_remove_message': '当計画書は削除されます。よろしいですか？',
      'remove_success_message': '計画書を削除しました。',
      'output_pdf_wait_message': '計画書PDFを出力中です。しばらくお待ちください。',
      'disable_patient_message': 'この患者は受付中止されました。',
      'validate_error_message': '計画書データーに誤りがあります。必須項目を正確に入力したかをご確認ください。',
      'plan_save_success_message': '計画書を保存しました。',
      'cancel_edit_message': 'データは保存されません。どうしますか？',
      'patient_photo_upload_message': 'ここにプロフィール写真をドラッグアンドドロップしてください。',
      'lead_plan1_default': '服薬状況の確認',
      'lead_plan2_default': '内服に関する遵守事項の確認',
      'nsips_patient_code_delete': '患者コードを削除します。よろしいですか？',
      'nsips_delete_success': '患者コードを削除しました。',
      'nsips_delete_failure': '患者コード削除に失敗しました。',
      'label': {
        'patient_photo': '患者写真',
        'patient_photo_upload': '患者写真アップロード',
        'tel': 'TEL',
        'post': '〒',
        'post_no': '郵便番号',
        'tel_no': '電話番号',
        'emergency_name': '連絡先名',
        'save_next_month': '翌月計画書自動作成',
        'copy_edit': '当計画書を元に月中新規作成',
        'plan_date': '計画作成日',
        'shop_name': '薬局名',
        'creator_name': '作成者',
        'clinic_name': '医療機関',
        'doctor_name': '主治医',
        'careoffice_name': '居宅支援事業所',
        'careman_name': 'ケアマネ',
        'facility_name': '施設',
        'address': '現住所',
        'relationship': '続柄',
        'emergency_address': '緊急連絡先住所',
        'emergency_address1': '住所１',
        'emergency_address2': '住所２',
        'pay_method_name': '支払方法',
        'side_effect_history': '副作用歴',
        'allergy_history': 'アレルギー歴',
        'visit_plan1': '訪問計画',
        'visit_plan2': '訪問回数',
        'disease_names': '医師からの情報',
        'disease_name': '【診断名】',
        'other_disease_name': 'その他',
        'body_character1': '患者の心身の特性',
        'body_character2': '注意すべき点',
        'complication': '合併症・既往歴',
        'complication1': '合併症',
        'complication2': '既往歴',
        'special_comment': '特記事項・調剤訪問における注意事項',
        'special_comment1': '特記事項',
        'special_comment2': '調剤訪問における',
        'special_comment3': '注意事項',
        'lead_plan1': '服薬支援',
        'lead_plan2': '服薬指導',
        'lead_plan3': '計画',
        'lead_plan6': '先月申送り事項',
        'meeting_comment1': '担当者会議',
        'meeting_comment2': '出席記録',
        'create_time': '作成日時',
        'patient_disable': '受付中止',
        'patient_enable': '受付再開',
        'pdf_output': 'PDF出力'
      }
    },
    'report': {
      'header_close': 'ヘッダーを閉じる',
      'header_open': 'ヘッダーを開く',
      'disp_item': '表示項目：',
      'room_no': '部屋番号',
      'haiyaku_naiyou': '配薬内容',
      'henkouten': '変更点',
      'shidou_naiyou': '指導内容',
      'kakunin_jikou': '確認事項',
      'patient_prev': '前の患者',
      'patient_next': '次の患者',
      'patient_count': '人',
      'patient_select': 'の患者を選択中。',
      'plan_reference': '計画書参照',
      'facility': '施設名',
      'facility_reference': '施設情報参照',
      'zenkai': '前回',
      'jikai': '次回',
      'shohoubi': '処方日',
      'chouzaibi': '調剤日',
      'report_type': '報告書種類',
      'teisyutsu': '提出',
      'clinic_send_check': '医師に提出',
      'careoffice_send_check': 'ケアマネに提出',
      'send_type': '送付方法',
      'post': '郵送',
      'fax': 'FAX',
      'fax_no': 'FAX番号',
      'email': 'メール',
      'fusezi': '伏字対応',
      'fusezi_ari': 'あり',
      'fusezi_nashi': 'なし',
      'fusezi_msg1': '報告書送信の時に患者名を伏字出力',
      'fusezi_msg2': '（例：山本　亮一 => ◯本　◯一）',
      'houmonbi': '訪問日',
      'shohou_nichi': '処方日数',
      'nichi': '日',
      'fukuyoukikan': '服薬期間',
      'fukuyoukaishi': '服用開始日',
      'divide': '～',
      'konkai_haiyaku': '今回配薬内容',
      'kusuri_reference': '薬情報参照',
      'mondai_nashi': '問題無し',
      'phrase': '定型文',
      'create_time': '記入日時',
      'update_time': '編集日時',
      'status': '状態',
      'nichisu': '日数',
      'patient_name': '患者名',
      'konkai_haitatsu': '今回配達',
      'birthday': '生年月日',
      'send_clinic': 'クリニック送信',
      're_send_careman': 'ケアマネ送信',
      'clinic_pdf': 'クリニック用PDF',
      'careman_pdf': 'ケアマネ用PDF',
      'renmei_pdf': '連名PDF',
      'yakureki_pdf': 'PDF',
      'cancelable': '送信中止',
      're_startable': '送信再開',
      'ijyou1': '以上、訪問服薬指導の内容をご報告いたします。',
      'ijyou2': '薬剤師',
      'report_delete': 'この報告書は削除されています。',
      'display_now': '表示中',
      'send_info_change': '提出先変更',
      'careoffice_send_not_setting1': '居宅支援事業所への送信は未設定です。',
      'careoffice_send_not_setting2': '※計画書に居宅支援事業所・ケアマネが登録されていません。',
      'send_timing': [
        {'id': '0', 'text': '当日○時間後送付'},
        {'id': '1', 'text': '１週間まとめ送付'},
        {'id': '2', 'text': '２週間まとめ送付'}
      ],
      'send_timing_hour': [
        {'id': '0.0', 'text': '０分後'},
        {'id': '0.5', 'text': '３０分後'},
        {'id': '1.0', 'text': '１時間後'},
        {'id': '2.0', 'text': '２時間後'},
        {'id': '3.0', 'text': '３時間後'},
        {'id': '4.0', 'text': '４時間後'},
        {'id': '5.0', 'text': '５時間後'},
        {'id': '6.0', 'text': '６時間後'},
        {'id': '7.0', 'text': '７時間後'},
        {'id': '8.0', 'text': '８時間後'},
        {'id': '9.0', 'text': '９時間後'},
        {'id': '10.0', 'text': '１０時間後'},
        {'id': '12.0', 'text': '１２時間後'}
      ],
      'period': [
        {'id': '3', 'text': '3'},
        {'id': '5', 'text': '5'},
        {'id': '7', 'text': '7'},
        {'id': '14', 'text': '14'},
        {'id': '21', 'text': '21'},
        {'id': '28', 'text': '28'},
        {'id': '35', 'text': '35'}
      ],
      'ari': '有',
      'nashi': '無',
      'ari_nashi': ['無', '有'],
      'ari_nashi_name': {
        'taking_status': '服薬状況',
        'remnant_status': '残薬',
        'condition_change': '体調変化',
        'side_effect_status': '副作用',
        'interaction': '相互作用',
        'take_interaction': '飲食物',
        'complication': '他科受診',
        'other_dosage': '併用薬',
        'otc_combination': 'OTC',
        'last_request': '後発希望',
        'visit_duty': '疑義照会',
        'dispense_idea': '調剤工夫',
        'medicine_notebook': 'お薬手帳'
      },
      'failure': '不良',
      'good': '良',
      'failure_good': ['不良', '良'],
      'method_name': [
        {'id': '0', 'text': '-'},
        {'id': '1', 'text': '朝'},
        {'id': '2', 'text': '昼'},
        {'id': '3', 'text': '夕'},
        {'id': '4', 'text': '就寝前'}
      ],
      'prescribe_change': {
        'rdo1': '定期薬変更あり',
        'rdo2': '定期薬変更無し',
        'rdo3': '臨時処方'
      },
      'modal': {
        'phrase': '定型文選択',
        'phrase_select0': '使用回数順',
        'phrase_select1': '定型文名称順',
        'save_confirm': '保存確認',
        'save_confirm_msg': 'データは保存されません。どうしますか？',
        'add_confirm': '追加作成',
        'add_confirm_msg': '報告書の追加作成します。よろしいでしょうか？',
        'print': '受付チェック表印刷・ダウンロード',
        'print_msg': '受付チェック表印刷・ダウンロード',
        'date': '日付一括入力',
        'date_msg1': '日付 ',
        'date_msg2': 'を選択している報告書の',
        'date_msg3': 'に設定します。',
        'date_list1': 'No',
        'date_list2': '患者名',
        'date_list3': '性別',
        'date_list4': '訪問日',
        'teiki': '定期提出',
        'teiki_msg': '選択した報告書を定期提出します。よろしいでしょうか？',
        'sokuji': '即時提出',
        'sokuji_msg1': '選択した報告書を',
        'sokuji_msg2': 'に提出します。よろしいですか？',
        'delete_confirm': '削除確認',
        'delete_msg': '当報告書は削除されます。よろしいですか？',
        're_send': '送信済み報告書保存',
        're_send_msg': '報告書を再送信しますか？',
        'none_re_send_msg_save': '再送信せずに保存',
        'restart': '報告書送信再開',
        'restart_msg1': '送信時刻：',
        'restart_msg2': '報告書送信を再開します。 よろしいですか？',
        'cancel': '送信中止',
        'cancel_msg': '報告書送信を中止します。よろしいですか？'
      }
    },
    'report_history': {
      'modal': {
        'report_back_send': '送信状態を「未送信」と戻します。よろしいでしょうか？',
        'resend_confirm': '再送信確認',
        'resend_confirm_text': '再送信します。よろしいですか？'
      }
    },
    'medicines': {
      'medicine_name': '薬品名',
      'select_type': '薬情報参照',
      'column_title1': '薬品名',
      'column_title2': '・概要',
      'csv_import_master': '②CSV一括更新(マスタ)',
      'csv_import_information': '①CSV一括更新(薬の説明)',
      'import_title_master': '医薬品マスタCSV一括更新',
      'import_title_information': '薬の説明データベースCSV一括更新',
      'import_comment_master': 'ここに医薬品マスタCSVをドラッグアンドドロップしてください。',
      'import_comment_information': 'ここに薬の説明データベースCSVをドラッグアンドドロップしてください。',
      'yj_code': 'YJコード',
      'medicine_type_name_none': '-- 薬種類 --',
      'medicine_type': '薬品種類',
      'sales_company': '販売会社名',
      'side_effect': '副作用',
      'err_file_length': 'ファイルは1件のみ処理可能です。',
      'outline': '概説',
      'additional_comment': '備考',
      'import_sucess_message': 'インポートが完了しました。'
    },
    'side_effect': {
      'connection': {
        'serious': 'による',
        'other': 'により',
        'medicine': 'は'
      },
      'end_word': {
        'serious': {
          'confirmed': 'などの副作用症状がないことを確認済み',
          'explain': 'などの副作用症状に注意していただくよう説明'
        },
        'other': {
          'confirmed': 'と確認済み',
          'explain': 'と説明'
        }
      }
    },
    'phrases': {
      'category': 'カテゴリ',
      'used_count': '使用回数',
      'new_regist': '新規登録',
      'times': '{times}回',
      'delete_confirm': '削除確認',
      'delete_confirm_text': '定型文を削除します。よろしいでしょうか？'
    },
    'send_pdf': {
      'send_address_select': '送信宛先指定',
      'csv_add': 'CSV登録',
      'send_address_list': '送信宛先一覧',
      'send_address': '宛先',
      'bulk_send': '一括送付',
      'confirm': '個の宛先が存在します。一括送付しますか？',
      'sending': 'しばらくお待ちください。PDFファイルを送付中です。',
      'completed': 'PDFを一括送付しました。',
      'canceled': 'PDF一括送付がキャンセルされました。',
      'csv_parsed': '住所ファイルを解析しました。',
      'facility_all': {'id': '0', 'name': '全施設'},
      'clinic_all': {'id': '0', 'name': '全クリニック'},
      'care_office_all': {'id': '0', 'name': '全介護支援事業所'},
      'facility_noData': '施設がありません',
      'clinic_noData': 'クリニックがありません',
      'careoffice_noData': '介護支援事業所がありません'
    },
    'shop_list': {
      'message': '切り替える店舗を選択してください。切り替え後、該当店舗が担当する施設にのみアクセスできます。',
      'shop_all': '全店舗',
      'current_shop': '現在の店舗',
      'shop_changed': '店舗を切り替えました。'
    },
    'care_office': {
      'care_office_name': '介護支援事業所名',
      'short_name': '事業所名',
      'address': '住所',
      'post': '〒',
      'post_no': '郵便番号',
      'address1': '住所１',
      'address2': '住所２',
      'tel': 'TEL',
      'fax': 'FAX',
      'send_type': '送付方法',
      'shop': '担当店舗',
      'login_id_prefix': 'KK',
      'delete_confirm': '削除確認',
      'new_regist': '新規登録',
      'delete_confirm_text': '介護支援事業所履歴を削除します。よろしいでしょうか？',
      'duplication_check': '重複チェック',
      'title_edit': '介護支援事業所編集',
      'title_new': '介護支援事業所新規登録',
      'save_success_message': '介護支援事業所情報を保存しました。',
      'loginid_password_notice': 'ログインIDとパスワードの通知',
      'loginid_password_notice_confirm': '先方へログインID・パスワードを通知します。よろしいですか？',
      'loginid_password_notice_message': '先方へログインID・パスワードを通知しました。',
      'no_select_mail_or_fax_message': 'メールやFAXが指定されていません。',
      'set_disable_success_message': '取引中止にしました。',
      'set_enable_success_message': '取引を再開しました。',
      'duplicate_tel_confirm': '登録確認',
      'duplicate_tel_message': '同じ電話番号がすでに登録済みです。このまま登録してよろしいですか？',
      'disabled_message': 'この介護支援事業所は取引中止されました。'
    },
    'doctor': {
      'doctor_name': '医師名',
      'clinic_name': 'クリニック名',
      'phone_num': '携帯TEL',
      'phone': 'TEL',
      'doctor_code': '医師コード　',
      'delete_confirm': '削除確認',
      'new_regist': '新規登録',
      'delete_confirm_text': '医師履歴を削除します。よろしいでしょうか？',
      'duplication_check': '重複チェック',
      'doctor_count': '医師件数',
      'title_edit': '医師編集',
      'title_new': '医師新規登録',
      'duplicate_tel_confirm': '登録確認',
      'duplicate_tel_message': '同じ電話番号がすでに登録済みです。このまま登録してよろしいですか？'
    },
    'careman': {
      'careman_name': 'ケアマネジャー',
      'careoffice_name': '介護支援事業所',
      'phone_num': '携帯TEL',
      'phone': 'TEL',
      'delete_confirm': '削除確認',
      'new_regist': '新規登録',
      'delete_confirm_text': 'ケアマネジャー履歴を削除します。よろしいでしょうか？',
      'duplication_check': '重複チェック',
      'careman_count': 'ケアマネジャー件数',
      'title_edit': 'ケアマネジャー編集',
      'title_new': 'ケアマネジャー新規登録',
      'duplicate_tel_confirm': '登録確認',
      'duplicate_tel_message': '同じ電話番号がすでに登録済みです。このまま登録してよろしいですか？'
    },
    'careoffice': {
      'careoffice': '事業所',
      'address': '住所',
      'tel': 'TEL',
      'post': '〒'
    },
    'history': {
      'max_year': 2099,
      'max_display': '',
      'today': '当日日付',
      'delimiter': '～',
      'reference_date': '基準日',
      'change_date': '変更日'
    },
    'login': {
      'forgot_password': 'パスワードをリセットする'
    },
    'forgot_password': {
      'input_email': '自分のメールアドレスをご入力してください。',
      'send_reset_email': 'パスワードをリセットするためのリンクが含まれているメールが入力したメールアドレスへ送信されます。',
      'back_to_login': 'すでにアカウントを持っていますか？',
      'completed': 'パスワードリセット用メールをお客様のメールアドレスへ届けました。メールからリンクをクリックして、パスワードをリセットしてください。'
    },
    'reset_password': {
      'input_new_password': '新しいパスワードを入力してください。',
      'reset_cancel': {
        'message1': 'パスワードリセットを取消し',
        'message2': 'します。'
      },
      'completed': 'パスワードがリセットされました。'
    },
    // 月次チェック
    'monthly_check': {
      'report_types': {
        '0': '居宅',
        '1': '薬歴',
        '2': '在宅',
        '4': 'か指',
        '5': 'か包'
      },
      'date_types': {
        'delivery_date': '訪問日',
        'prescribe_date': '処方日',
        'make_date': '調剤日'
      }
    },
    'nsips': {
      'patient': {
        'unregistered_title': 'ファムケア未登録の患者データがあります。',
        'unregistered_content': 'レセコンデータの患者を選択して、「新規登録」「外来登録」「登録済み患者を選択」のいずれかの処理を実施してください。',
        'modal_title': '患者データ関連付け',
        'modal_content': '以下のデータを関連付けます。よろしいでしょうか？',
        'modal_not_selected': '選択されていません',
        'modal_nsips': 'レセコンデータ',
        'modal_famcare': 'ファムケアデータ'
      },
      'clinic': {
        'unregistered_title': 'ファムケア未登録のクリニックデータがあります。',
        'unregistered_content': 'レセコンデータのクリニックを選択して、「新規登録」「登録済みクリニックを選択」のいずれかの処理を実施してください。',
        'modal_title': 'クリニックデータ関連付け',
        'modal_content': '以下のデータを関連付けます。よろしいでしょうか？',
        'modal_not_selected': '選択されていません',
        'modal_nsips': 'レセコンデータ',
        'modal_famcare': 'ファムケアデータ'
      },
      'doctor': {
        'unregistered_title': 'ファムケア未登録の医師データがあります。',
        'unregistered_content': 'レセコンデータの医師を選択して、「新規登録」「登録済み医師を選択」のいずれかの処理を実施してください。',
        'modal_title': '医師データ関連付け',
        'modal_content': '以下のデータを関連付けます。よろしいでしょうか？',
        'modal_not_selected': '選択されていません',
        'modal_nsips': 'レセコンデータ',
        'modal_famcare': 'ファムケアデータ'
      },
      'relation_remove': {
        'success': '解除に成功しました。',
        'failure': '解除に失敗しました。',
        'patient': '患者データの関連付けを解除します。よろしいでしょうか？',
        'clinic': 'クリニックデータの関連付けを解除します。よろしいでしょうか？',
        'doctor': '医師データの関連付けを解除します。よろしいでしょうか？'
      }
    },
    'messages': {
      'complete': '完了しました。',
      'wait_responding': 'データー取得中…',
      'upload_fail': 'アップロードが失敗しました。',
      'select_list_item': '登録先から選択してください。',
      'search': {
        'danger': '検索に失敗しました。',
        'warning': '検索に成功しましたが、問題が発生しました。'
      },
      'save': {
        'success': '保存しました。',
        'report_warning': '報告書情報を保存しました。未入力項目があります。',
        'report_select_success': '選択された報告書を保存しました。',
        'facility_stop_success': '取引中止にしました。',
        'facility_restart_success': '取引を再開しました。',
        'facility_code_duplicate': 'この施設コードはすでに利用しています。',
        'floor_code_duplicate': 'フロアーコードが重複しています。',
        'danger': '保存に失敗しました。',
        'warning': '保存に成功しましたが、問題が発生しました。',
        'clinic_stop_success': '取引中止にしました。',
        'clinic_restart_success': '取引を再開しました。'
      },
      'delete': {
        'success': '削除しました。',
        'danger': '削除に失敗しました。',
        'warning': '削除に成功しましたが、問題が発生しました。',
        'success_report_delete': '報告書を削除しました。'
      },
      'send': {
        'send_report': '報告書を送信しました。',
        'success_report_pauling': '選択された報告書を定期提出しました。',
        'danger_report_pauling': '定期提出に失敗しました。',
        'success_report_immediate': '選択された報告書を即時提出しました。',
        'danger_report_immediate': '即時提出に失敗しました。',
        'danger_required': '様の報告書データーに誤りがあります。報告書作成画面から必須項目を正確に入力したかをご確認ください。',
        'danger_send_check': '様の報告書は送付方法でメールを選択しています。しかし、医師もしくはケアマネのメールアドレスが設定されていません。',
        'success_report_stop': '報告書の送信を中止しました。',
        'danger_report_stop': '報告書の送信中止に失敗しました。',
        'success_report_restart': '報告書送信を再開しました。',
        'danger_report_restart': '報告書送信の再開に失敗しました。'
      },
      'pdf': {
        'danger': 'PDF出力に失敗しました。'
      },
      'print': {
        'danger': '印刷に失敗しました。',
        'not_found': '印刷するデータが存在しません。'
      },
      'send_medinfo': {
        'mail_fax_none_setting': 'メールやFAXが指定されていません。',
        'success': '先方へログインID・パスワードを通知しました。',
        'danger': '通知に失敗しました。'
      },
      'maxlength': {
        'danger': '「{name}」は{len}文字以上入力できません。'
      }
    },
    'Help Modal': {
      'Modal Title': {
        'Report Create': '報告書作成ヘルプ',
        'Facility List': '施設一覧ヘルプ',
        'Facility Edit': '施設編集ヘルプ',
        'Facility Person List': '個人宅一覧ヘルプ',
        'Facility Person Edit': '個人宅編集ヘルプ',
        'Clinic List': 'クリニック一覧ヘルプ',
        'Clinic Edit': 'クリニック編集ヘルプ',
        'Doctor List': '医師一覧ヘルプ',
        'Doctor Edit': '医師編集ヘルプ',
        'Care Office List': '介護支援事業所一覧ヘルプ',
        'Care Office Edit': '介護支援事業所編集ヘルプ',
        'Care Manager List': 'ケアマネージャー一覧ヘルプ',
        'Care Manager Edit': 'ケアマネージャー編集ヘルプ',
        'Send PDF': 'PDF一括送付ヘルプ',
        'Report History': '報告書送信履歴ヘルプ',
        'Patient List': '患者検索ヘルプ',
        'Shop List': '店舗別情報一覧ヘルプ',
        'Shop Edit': '店舗別情報登録ヘルプ',
        'Plan Detail': '計画書詳細ヘルプ'
      },
      'Discription': {
        'Print': '指定した訪問日を基準にチェックした表示項目の一覧表を出力します。',
        'Send Report Ordinary': 'クリニック情報、介護支援事業所情報の送付手段、送付時間で送付します。',
        'Send Report Immediately': 'クリニック情報、介護支援事業所情報の送付手段ですぐに送付します。',
        'Input Support': '指導内容が空欄の場合、任意の定型文が記入されます。',
        'Autoinput Date': 'チェックした患者の日付を一括して変更します。',
        'Disp Item': '画面及び「印刷」で出力する一覧表に表示する項目を選択します。',
        'Base Date': '編集履歴をもとに指定した日付の情報を表示します。',
        'Change Date': '指定した日付から情報を変更します。',
        'Deal Ends': '報告書作成の施設選択や患者検索、施設・医療機関情報で非表示にします。患者検索、施設・医療機関情報では「取引中止先」にチェックすると表示されます。',
        'Patient Deal Ends': '計画書で「受付中止」した患者や「取引中止」した施設、クリニックを表示します。',
        'Tel Duplicate Check': '電話番号で照合し、重複して登録されている施設やクリニックの一覧を表示します。',
        'Facility Surrounding': 'チェックした施設を地図上に表示します。',
        'Facility Surrounding By Shop': 'チェックした店舗に属している施設を地図上にします。',
        'Clinic Surrounding By Shop': 'チェックした店舗に属しているクリニックを地図上にします。',
        'Care Office Surrounding By Shop': '選択すると出て来るモーダルの店舗を選択すると、選択した店舗に所属する介護支援事業所の位置を検索します。',
        'CSV Regist Format': '送付先名称、FAX番号をCSVファイルで一括登録します。',
        'Send Check': '押すと送信済みに変更されます。送付方法が郵送の場合、送付管理に活用できます。',
        'Return': '送信状態が「送信確認」に戻ります。',
        'Send Stop': '送信予定の報告書を送信中止します。',
        'FAX Header': '送信したときに相手側の記録紙の一番上に記入します。',
        'Report Message': '送付状のお知らせ欄に記入します。',
        'Report Flg': '報告書の作成日時や編集日時を報告書印刷時または送信時に表示します。',
        'Stop Acceptance': '報告書作成の患者選択で非表示にします。'
      }
    }, // 外来患者
    'Outpatient': {
      'Search Outpatients': '外来患者検索',
      'Search Patients': '在宅患者検索',
      'denger': 'すでに在宅患者として登録されています',
      'Detail': '外来患者詳細',
      'Outpatient': '外来患者',
      'Patient': '在宅患者',
      'Select Outpatient': '外来患者選択',
      'Name': '外来患者名',
      'New Regist': '外来患者新規登録',
      'Create patient': '在宅患者切替',
      'Edit Regist': '外来患者編集',
      'Patient Code': '患者コード',
      'Create Date': '作成日',
      'birthday': '生年月日',
      'sex': '性別',
      'age': '年齢',
      'count': '外来患者件数',
      'shop': '店舗',
      'delete_confirm': '削除確認',
      'delete_confirm_text': '削除してよろしいですか？'
    },
    'Header Title': 'ファムケア報告書',
    'Home': 'ホーム',
    'Search': '検索',
    'Plan': '計画書',
    'Report': '報告書',
    'Create Report': '報告書作成',
    'Report History': '報告書送信履歴',
    'Monthly Check': '月次チェック',
    'Create Plan': '計画書作成(患者登録)',
    'Create Plan xs': '計画書作成',
    'Plan Show': '計画書参照',
    'Plan Detail': '計画書詳細',
    'Plan Edit': '計画書編集',
    'Patient': '患者',
    'Search Patients': '患者検索',
    'Facility Clinic': '施設・医療機関',
    'Surrounding Facility': '周辺施設',
    'User Shop': '社員・店舗',
    'Phrase': '定型文',
    'Phrase List': '定型文一覧',
    'Medicine': '薬情報',
    'Medicine List': '薬情報一覧',
    'Edit Medicine': '薬情報編集',
    'Create Bill': '請求書作成',
    'Bill History': '請求書履歴',
    'Print All': '一括印刷',
    'Send PDF': 'PDF一括送付',
    'Send PDF History': 'PDF送信履歴',
    'Shop': '店舗',
    'Change Shop': '店舗切替',
    'Help': 'ヘルプ',
    'Select Shop': '店舗選択',
    'Facility': '施設',
    'Select Facility': '施設選択',
    'Facility Count': '施設件数',
    'Facility Detail': '施設詳細',
    'Facility All': '施設・その他',
    'Register Facility': '施設新規登録',
    'Edit Facility': '施設編集',
    'Facility Person': '個人宅',
    'Please Select Facility': '施設を選択してください。',
    'Select Facility Person': '個人宅選択',
    'Please Select Facility Person': '個人宅を選択してください。',
    'Facility Person Count': '個人宅件数',
    'Facility Person Detail': '個人宅詳細',
    'Facility Person Redister': '個人宅新規登録',
    'Facility Person Edit': '個人宅編集',
    'Clinic': 'クリニック',
    'Select Clinic': 'クリニック選択',
    'Please Select Clinic': 'クリニックを選択してください。',
    'Clinic Count': 'クリニック件数',
    'Doctor': '医師',
    'Select Doctor': '医師選択',
    'Please Select Doctor': '医師を選択してください。',
    'Care Office': '介護支援事業所',
    'Select Care Office': '介護支援事業所選択',
    'Please Select Care Office': '介護支援事業所を選択してください。',
    'Care Office Count': '介護支援事業所件数',
    'Care Manager': 'ケアマネージャー',
    'Select Care Manager': 'ケアマネージャー選択',
    'Please Select Care Manager': 'ケアマネージャーを選択してください。',
    'Select Patient': '患者選択',
    'Report Edit': '報告書作成',
    'Report Show': '報告書参照',
    'Report Detail': '報告書詳細',
    'Shop Edit List': '店舗別情報一覧',
    'Shop Edit': '店舗別情報登録',
    'Send Report Ordinary': '定期提出',
    'Send Report Immediately': '即時提出',
    'Auto Input': '補助入力',
    'Auto Input Date': '日付一括入力',
    'Patient All Select': '全患者選択',
    'Word50': {'All': '全', 'W0': 'あ', 'W1': 'か', 'W2': 'さ', 'W3': 'た', 'W4': 'な', 'W5': 'は', 'W6': 'ま', 'W7': 'や', 'W8': 'ら', 'W9': 'わ', 'W10': '他'},
    'Top': 'Top',
    'Clinic Name': '医療機関名',
    'Doctor Name': '処方医名',
    'Reportor Name': '作成者',
    'Torihiki Stop': '取引中止先',
    'Login': 'ログイン',
    'Logout': 'ログアウト',
    'Read More': 'さらに読み込む',
    'View More': 'さらに表示',
    'Read All': 'すべて見る',
    'Count': '{Count}件',
    'Count Only': '件',
    'Send Error Count': '送信エラー{Count}件',
    'Link Name': 'マスタ管理システム',
    'Link Notes': '(※別タブで開きます)',
    'Under Construction': '工事中',
    'Clear': 'クリア',
    'Close': '閉じる',
    'Cancel': 'キャンセル',
    'Back': '戻る',
    'Print': '印刷',
    'Download': 'ダウンロード',
    'Pdf Download': 'PDFダウンロード',
    'Double Dot': '・',
    'Double Space': '　',
    'Double Space2': '　　',
    'Copy': 'コピー',
    'Setting': '設定',
    'Decision': '決定',
    'Complete': '完了',
    'Add Make': '追加作成',
    'Save': '保存',
    'ImageSave': '画像保存',
    'Save None': '保存しない',
    'Update': '更新',
    'age': '{age}歳',
    'honorific': '様',
    'Login ID': 'ログインID',
    'Password': 'パスワード',
    'Send Clinic Status': 'クリニック送信状況',
    'Send CareManeger Status': 'ケアマネ送信状況',
    'Search Counts': '検索件数',
    'Need to login': 'ログインしてください。',
    'No Data': 'データがありません。',
    'Delete Confirm': '削除してよろしいですか？',
    'Update Successful': '正常に更新されました。',
    'Avatar Upload Successful': '患者写真をアップロードしました。',
    'File Upload Successful': 'ファイルをアップロードしました。',
    'Prev Page': '前のページ',
    'Next Page': '次のページ',
    'Send History': '送信履歴',
    'Batch Send History': 'まとめ送信履歴',
    'Unsend History': '未送信履歴',
    'Error Send History': 'エラー送信履歴',
    'Destination': '送信先',
    'Reserved Send Time': '送信予定',
    'Send Confirm': '送信確認',
    'Back Post Send': '戻す',
    'Male': '男性',
    'Female': '女性',
    'Display': '表示',
    'Explain': '説明',
    'Confirm': '確認',
    'Edit': '編集',
    'OK': 'OK',
    'Yes': 'はい',
    'No': 'いいえ',
    'Add': '追加',
    'Delete': '削除',
    'PDF File': 'PDFファイル',
    'PDF FileName': '[PDFファイル名]',
    'Fax Number': 'FAX番号',
    'Mail Address': 'メールアドレス',
    'Mail': 'メール',
    'Detail': '詳細',
    'Name': '名前',
    'Furigana': 'ふりがな',
    'Phone Number': '電話番号',
    'Send': '送信',
    'Current Password': '現在のパスワード',
    'New Password': '新しいパスワード',
    'New Password Retyped': '新しいパスワード(確認)',
    'Password Reset': 'パスワードリセット',
    'Reset': 'リセット',
    'Google Map Mark': '地図で該当位置をクリックすると、マークが付けられます。',
    'Google Logo': '左下のGoogle(青文字)をクリックすると、別ウィンドウで開きます。',
    'Image Upload': '画像アップロード',
    'Image Upload Message': 'ここにファイルをドロップしてください',
    'Image Upload Successful': 'ファイルをアップロードしました。',
    'Title': 'タイトル',
    'Image Title Edit': 'タイトル入力',
    'Deal Ends': '取引中止',
    'Deal Resume': '取引再開',
    'Image Regist': '画像登録',
    'Image Description': '例）施設内地図、薬管理BOX、名刺、外観写真、駐車場など',
    'Mark Clear': 'マーククリア',
    'LoginID Password Notify': 'ログインID・パスワード送信',
    'LoginID Password Notify PDF': 'ログインID・パスワードPDF出力',
    'My Profile': 'マイページ',
    'Maintenance': 'メンテナンス中です。しばらくお待ちください。',
    'Nsips Patient Data Already Exists': '患者新規データあり',
    'Nsips Clinic Data Already Exists': 'クリニック新規データあり',
    'Nsips Doctor Data Already Exists': '医師新規データあり',
    'Nsips Relation Situations': 'レセコンデータ登録状況',
    'Over Shop Count Error Msg': '選択できる店舗は最大{max}つまでです。',
    'disp facility by store': '店舗別担当施設表示',
    'facility by store': '店舗別担当施設',
    'disp clinic by store': '店舗別担当クリニック表示',
    'clinic by store': '店舗別担当クリニック',
    'disp care office by store': '店舗別担当介護支援事業所表示',
    'care office by store': '店舗別担当介護支援事業所',
    'Nsips New Patient': '患者新規登録',
    'Nsips New Clinic': 'クリニック新規登録',
    'Nsips New Doctor': '医師新規登録',
    'Resend': '再送信',
    'Not registered': '未登録あり'
  }
}



// WEBPACK FOOTER //
// ./src/i18n.js